import { Directive } from '@angular/core';
import { NG_VALIDATORS, UntypedFormGroup, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[interestOnlyAmountValidator]',
  // eslint-disable-next-line no-use-before-define
  providers: [{ provide: NG_VALIDATORS, useExisting: InterestOnlyAmountValidatorDirective, multi: true }],
})
export class InterestOnlyAmountValidatorDirective implements Validator {
  public validate(formGroup: UntypedFormGroup): ValidationErrors {
    const interestOnlyAmountControl = formGroup.controls['interestOnlyAmount'];
    const loanAmountControl = formGroup.controls['loanAmount'];

    if (!interestOnlyAmountControl || !loanAmountControl) {
      return null;
    }

    if (interestOnlyAmountControl.errors && !interestOnlyAmountControl.errors.ioLessThanLoanAmount) {
      return null;
    }

    const valid = interestOnlyAmountControl.value < loanAmountControl.value;

    const errors = valid ? null : { ioLessThanLoanAmount: true };

    interestOnlyAmountControl.setErrors(errors);

    return errors;
  }
}
